import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-storage-dialogue',
  templateUrl: './storage-dialogue.component.html',
  styleUrls: ['./storage-dialogue.component.css']
})
export class StorageDialogueComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
